import axios from "axios";
import $ from 'jquery';

$(document).ready(() => {
    $("body").on("click", "#reset-btn", event => {
        // Get the email input element as DOM element for validity checking
        const emailInput = document.getElementById('reset-email');
        // Set the type to email to leverage HTML5 validation
        emailInput.type = 'email';
        
        let email = $('#reset-email').val();

        if (!email || !email.trim().length) {
            UIkit.notification('<span class="uk-text-danger">Please provide a valid email address!</span>');
        } else if (!emailInput.checkValidity()) {
            UIkit.notification('<span class="uk-text-danger">Please provide a valid email format!</span>');
        } else {
            axios({
                method: "post",
                url: "/api/reset/password",
                headers: {
                    "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content")
                },
                data: {
                    email,
                }
            }).then(response => {
                console.log("RESPONSE");
                if (response && response.data && response.data.status && (response.data.status == 200)) {
                    UIkit.notification('<span class="uk-text-success">'+ response.data.message +'</span>');
                } else if (response && response.data && response.data.message) {
                    UIkit.notification('<span class="uk-text-danger">'+ response.data.message +'</span>');
                }
                console.log(response, response.message);
            }).catch(error => {
                console.log(error);
                UIkit.notification('<span class="uk-text-danger">An error occurred. Please try again later.</span>');
            })
        }
    });
    
    $("body").on("click", "#home-btn", () => {
        window.location = '/';
    });
 
    $("body").on("click", "#save-reset-btn", event => {
        let password = $('#reset-password').val();
        let passwordConfirm = $('#reset-password-confirm').val();
        let token = $('#reset-token').val();
        
        // Basic validation
        if (!token || token.trim().length === 0) {
            UIkit.notification('<span class="uk-text-danger">Invalid reset token. Please request a new password reset.</span>');
            return;
        }

        if (!password || !passwordConfirm || !passwordConfirm.trim().length || !password.trim().length || !(password.trim() == passwordConfirm.trim())) {
            UIkit.notification('<span class="uk-text-danger">Both password fields are required and cannot be different.</span>');
        } else {
            axios({
                method: "post",
                url: "/api/reset/save",
                headers: {
                    "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content")
                },
                data: {
                    password,
                    token
                }
            }).then(response => {
                if (response && response.data && response.data.status && (response.data.status == 200)) {
                    UIkit.notification('<span class="uk-text-success">'+ response.data.message + '<br><br> Redirecting...' +'</span>');
                    setTimeout(()=> {
                        window.location = '/';
                    }, 3000);
                } else {
                    UIkit.notification('<span class="uk-text-danger">'+ response.data.message +'</span>');
                }
            }).catch(error => {
                console.log(error);
            })
        }
    });
});